import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';

@Component({
  selector: 'dr-ops-stream-ui-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'status',
    'aria-live': 'polite',
  },
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmptyStateComponent {
  readonly showPermissionStatusSignal = input<boolean>(false, { alias: 'showPermissionStatus' });
  readonly titleSignal = input<string>('No data available', { alias: 'title' });
  readonly permissionTextSignal = input<string>('Check your permission status.', { alias: 'permissionText' });
}
